import styled from 'styled-components';

export const StyledLogoHeader = styled.div`
	width: 100%;
  padding: 9px 30px;
  height: 60px;
  background-color: ${({ theme }) => theme.fontColors.white};
  border-bottom: ${({ theme }) => theme.borders.divider};
`;
